import { Button } from "reactstrap";
import AppDrawer from "../../../components/Drawers/AppDrawer";
import { DrawerProps } from "../../../components/Drawers/DrawerTypes";
import { List } from "./GlobalVariableListDetailView";
import { useMemo } from "react";
import AppCopy from "../../../components/AppComponents/AppCopy";
import { downloadJSON } from "../../../utils/FileUtils";
import dayjs from "dayjs";

interface Props extends DrawerProps {
  list: List | undefined;
}

export default function ExportGlobalListDrawer({ open, onClose, list }: Props) {
  const slimList = useMemo(() => {
    if (!list || !open) return [];

    return {
      Name: list.Name,
      APIName: list.APIName,
      Variables: list.Variables.map((v) => ({
        Name: v.Name,
        Value: v.Value,
      })),
    };
  }, [list, open]);

  const stringifiedList = JSON.stringify(slimList, null, 2);

  return (
    <AppDrawer
      open={open}
      onClose={onClose}
      body={
        <>
          <div className="d-flex justify-content-between align-items-center mb-1">
            <h4 className="mb-0">JSON</h4>
            <AppCopy text={stringifiedList} />
          </div>
          <div className="bg-superlight pt-2 px-3 rounded border">
            <pre>{stringifiedList}</pre>
          </div>
        </>
      }
      headerTitle={`Download ${list?.Name || "List"}`}
      headerOptions={
        <Button size="sm" onClick={downloadList} color="primary">
          Download
        </Button>
      }
    />
  );

  function downloadList() {
    downloadJSON(slimList, `${list?.APIName}-${dayjs().format("MM-DD-YYYY")}`);
  }
}
